var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHighlighterCircle = function SvgIconHighlighterCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.194 21.08A10 10 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a10 10 0 0 0 5.86 9.106A10 10 0 0 0 12 22a10 10 0 0 0 4.194-.92M12 4a8 8 0 0 0-4.75 14.438v-3.813a1.75 1.75 0 0 1 1.5-1.732V9.75a1 1 0 0 1 .553-.894l4.5-2.25a1 1 0 0 1 1.447.894v5.393a1.75 1.75 0 0 1 1.5 1.732v3.813A8 8 0 0 0 12 4m2.75 15.515v-4.64h-5.5v4.64A8 8 0 0 0 12 20c.966 0 1.893-.171 2.75-.485m-4-6.64h2.5V9.118l-2.5 1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHighlighterCircle;